import styled from "styled-components";
export const Conten = styled.div`
margin: 0;
`;

